import React, { useState } from "react";
import "./TestStyles.css";

/**
 * The DropDownComponent is a functional component in JavaScript that handles the change event of a
 * dropdown and updates the selected value in state and local storage.
 */
const DropDownComponent = ({ options, className, placeholder }) => {
  const [selectedValue, setSelectedValue] = useState("");
  const handleDropdownChange = (event) => {
    setSelectedValue(event.target.value);
    localStorage.setItem(event.target.className, event.target.value);
  };

  return (
    <div>
      <select className={className} value={selectedValue} onChange={handleDropdownChange}>
        <option value="" disabled hidden>
          {placeholder}
        </option>

        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropDownComponent;
